import FormattedMessage from 'I18n/components/FormattedMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import EnrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/EnrollmentAnalysisDetails';
import RecordTimelineTabContent from 'flow-doctor-lib/components/diagnosis/tabs/RecordTimelineTabContent';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentDiagnosisPanelTabs = ({
  diagnosisResult,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsxs(UITabs, {
    defaultSelected: "enrollmentInfo",
    use: "enclosed",
    fill: true,
    children: [/*#__PURE__*/_jsx(UITab, {
      tabId: "enrollmentInfo",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.tabs.info"
      }),
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: "1000",
        paddingBlockEnd: "600",
        as: "div",
        children: /*#__PURE__*/_jsx(EnrollmentAnalysisDetails, {
          selectedEnrollment: selectedEnrollment,
          diagnosisResult: diagnosisResult
        })
      })
    }), /*#__PURE__*/_jsx(UITab, {
      tabId: "recordTimeline",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.tabs.timeline"
      }),
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: "1000",
        as: "div",
        children: /*#__PURE__*/_jsx(RecordTimelineTabContent, {
          diagnosisResult: diagnosisResult,
          selectedEnrollment: selectedEnrollment
        })
      })
    })]
  });
};
export default EnrollmentDiagnosisPanelTabs;